<section
  class="padding-top-body"
  [ngStyle]="{ 'background-color': 'var(--secondary-celeste2)' }"
></section>

<app-akky-pro-hero
  title="Akky Pro"
  subtitle="A MAYOR INVERSIÓN, MAYOR DESCUENTO"
  backgroundColor="var(--burgundy2)"
  buttonText="Quiero saber más"
  textColor="white"
  titleSize="48px"
  subtitleSize="20px"
  [isSubtitleBold]="true"
/>

<app-akky-pro-banner />

<app-akky-pro-benefits backgroundColor="var(--bs-gray-300)" />

<app-akky-pro-panel />

<app-akky-pro-termns-and-conditions backgroundColor="var(--bs-gray-300)" />
<!-- TODO: Uncomment this when the recomendation sistem are ready -->
<!-- <app-akky-pro-recommendation-carousel [recommendations]="recommendations" /> -->

<app-akky-pro-hero
  title="¿Estás listo para crecer a lo grande?"
  subtitle="Conviértete en parte de Akky Pro y desbloquea nuevas oportunidades para tu negocio digital. "
  backgroundColor="var(--burgundy)"
  subtitle="Conviértete en parte de Akky Pro y desbloquea nuevas oportunidades para tu negocio digital. "
  backgroundColor="var(--burgundy)"
  buttonText="Quiero saber más"
  textColor="white"
  titleSize="28px"
  subtitleSize="28px"
  [isSubtitleBold]="false"
/>
